$(document).ready(function () {
  
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  gsap.registerPlugin(ScrollTrigger,ScrollToPlugin); 



  function hideShoppable() {
    var x = $('#shop-collection #product-grid').html();

    if($('#shop-collection #product-grid').length) {
      console.log('with shop');
    } else {
      console.log('no shop');
      $('.collection-button-group').hide();
    }
  
  }

  hideShoppable();


  
  function initHeight() {
    var vw = $(window).width();
    var wh = $(window).height();
    var viewportHeight = ((wh - ($('.header-wrapper').height())) +1);
    $('.flexheight').css('height',viewportHeight);

    if (vw > 750){
      $('#collections-all .card, #collections-all .card__inner').css('height',viewportHeight);
    } else {
      $('#collections-all .card, #collections-all .card__inner').css('height',viewportHeight*0.65);
    }
  }

  initHeight();

  $(window).resize(function(){
    initHeight();
  });


  $('.form__label').each(function(){
    var x = $(this).text();
    if (x=='Color') {
      // console.log('t');
      $(this).parent('.product-form__input').hide();
    }
    
  });

  /* if more than 3 image, arrange green report */
  if(($('.product__media-list li').length) > 3) {
    console.log('more');
    $('.triarchy-responsibility-report').insertAfter('.product__media-list li:nth-child(3)');
  }

  
  
  function hello() {
   // console.log('hello');
  var x = $('#supplychain').html();
  // console.log(x);

   // $('.triarchy-responsibility-report').append(x);

    setTimeout(function(){
      // hello()
    }, 3000);
  }

  hello();
  



      $('.close-panel').click(function(){
        var x = $(this).attr('data-close');
          $('.sustainabilityProof').removeClass('heightanimation');
          $('.softTag').removeClass('selectedTag');
          $('#supplychain').removeClass('visible');
          $(this).fadeOut(200);
          return false;
      });


      $('.softTag').click(function(){    
        gsap.to(window, {duration: .5, scrollTo:{y:"#sustainabilityProof", offsetY: 60}});
        $('.close-panel').show();
      });

      
    
    


  

  // setTimeout(function(){
  //   $('#widget-renoon').addClass('is-loaded');
  // },1000);

   $('#widget-renoon').addClass('is-loaded');
   

  $('.mobile-menu').click(function(){
    if($('.mobile-menu-button').hasClass('close')) {
      $('.mobile-menu-button').removeClass('close');
      $('.header__icon--account, .header__icon--cart, .header__search').css('opacity','1');
      $('.module-mobile-menu').removeClass('open');
    } else {
      $('.mobile-menu-button').addClass('close');
      $('.header__icon--account, .header__icon--cart, .header__search').css('opacity','0');
      $('.module-mobile-menu').addClass('open');
    }

    return false;
  });

  $('.level-2').each(function(){
      var x = $(this).height();
      var y = $(this).attr('data-open');
      $(this).css('height',x).addClass('hide');
      $(this).parent('.level-1').prepend('<span class="open-sub-menu">+</span>');

      if(y == 'true') {
        $(this).removeClass('hide');
        $(this).parent('.level-1').find('.open-sub-menu').text('-');
      }
  });

  $('.open-sub-menu').click(function(){

    if ($(this).siblings('.level-2').hasClass('hide')) {
      $('.level-2').addClass('hide');
      $('.open-sub-menu').text('+');
      $(this).text('-').siblings('.level-2').removeClass('hide');
    } else {
      $(this).text('+').siblings('.level-2').addClass('hide');
    }
    
  });


  
  $('#MainContent').addClass('is-loaded');

  $('.scrollto').click(function(){
    var x = $(this).attr('href');
    var a = $(this).attr('data-offset');
    var b = $(this).attr('data-duration');
    gsap.to(window, {duration: b, scrollTo:{y: x, offsetY: a}});
    return false;
  });

  $('.marquee-scroll').each(function(){
      var x = $(this).text();
      var m1 = '<div class="marquee marquee-1"><div class="text-2">'+x+'</div><div class="marquee-spacer"></div><div class="text-1">'+x+'</div><div class="marquee-spacer"></div><div class="text-2">'+x+'</div><div class="marquee-spacer"></div><div class="text-2">'+x+'</div><div class="marquee-spacer"></div></div>';
      var m2 = '<div class="marquee marquee-2"><div class="text-1">'+x+'</div><div class="marquee-spacer"></div><div class="text-2">'+x+'</div><div class="marquee-spacer"></div><div class="text-1">'+x+'</div><div class="marquee-spacer"></div><div class="text-2">'+x+'</div><div class="marquee-spacer"></div></div>';
      $(this).html('<div class="marquee-wrap">'+m1+m2+'</div>');
  });
  
 

  $("#MegaMenu-Content-1 .mega-menu__list").append(
    '<div><img src="https://cdn.shopify.com/s/files/1/0801/2873/7579/files/menu-banner.jpg?v=1693289546&width=750"></div>'
  );

  $("#MegaMenu-Content-2 .mega-menu__list").append(
    '<div><img src="https://triarchydev.myshopify.com/cdn/shop/collections/SS23-cover.jpg?v=1693204230&width=750"></div><div><img src="https://triarchydev.myshopify.com/cdn/shop/collections/Triarchy-Sale.jpg?v=1693207493&width=750"></div>'
  );

  $("#MegaMenu-Content-3").prepend(
    '<div><img src="https://triarchy.com/cdn/shop/files/triarchy-hmpayw-01.jpg?v=10408185074098022321&width=750"></div>'
  );

  /*
  $(".product__media-list").append(
    '<div class="triarchy-responsibility-report"><div class="copy"><h2>Responsibility Report</h2><p>Transparency is an important part of our philosophy which is why we have partnered with the transparency platform Renoon. We provide you with precise information that can help you make responsible choices. A proof point with the tick represents the highest level of verification, meaning that you can check the proving document of that value or information by yourself.</p><div class="gs-product-container"><gs-product widgettype="product" clientid ="KPAkTONbLejg8DAGXdMy5xixxxgt5jLZ" productid="40101"></gs-product></div><div id="widget-renoon" style="display: none"></div></div></div>'
  );
  */

  $(".gs-offset-container").append(
    `<gs-offset clientid="KPAkTONbLejg8DAGXdMy5xixxxgt5jLZ" productId="${productId}" ></gs-offset>`
  );

  $(".gs-counter-container").append(
    '<gs-counter widgettype="counter" clientid="KPAkTONbLejg8DAGXdMy5xixxxgt5jLZ" ></gs-counter>'
  );

  $("div[data-parent-id]").each(function () {
    var x = $(this).attr("data-parent-id");

    $(this)
      .parents("section")
      .addClass("triarchy-block triarchy-block-" + x);
  });

  /*
  if ($(".facets-container").length) {
    var z =
      $(".announcement-bar-section").height() +
      $(".shopify-section-header-sticky").height();

    var y = $(".shopify-section-header-sticky").height();

    $(window).scroll(function () {
      var x = $(window).scrollTop();
      console.log(x);

      if (x > z) {
        $(".facets-container").css("top", y).addClass("stick");
      } else {
        $(".facets-container").removeClass("stick");
      }
    });
  }
  */

  $(window).scroll(function () {
    var x = $(".collection-hero").height();
    var y = $(window).scrollTop();
    var heightHeight = $('.header-wrapper').height();

    $('.collection-navigation').css('top',heightHeight);
    
    if (y > x) {
      $(".collection-navigation").addClass("enter");
    } else {
      $(".collection-navigation").removeClass("enter");
    }    
  });

  $(".list-menu li").mouseover(function () {
    $(".mega-menu").removeAttr("open");
    $(this).find(".mega-menu").attr("open", "open");
  });

  $(".header-wrapper").mouseleave(function () {
    $(".mega-menu").removeAttr("open");
  });

  var vw = $(window).width();

  if (vw > 749) {
    $(".list-menu li:first-child").click(function () {
      window.location.href = "/collections/all";
    });
  
    $(".list-menu li:nth-child(2)").click(function () {
      window.location.href = "/collections";
    });
  
    $(".list-menu li:nth-child(3)").click(function () {
      window.location.href = "/pages/our-story";
    });
  } else {
    $('.triarchy-responsibility-report').appendTo('.product__info-wrapper');
    $('.triarchy-responsibility-report').click(function(){
        $('.sustainabilityProof').removeClass('heightanimation');
    });
  }

  setTimeout(function () {
    $(
      "#Details-ec3c1a27-681f-4f74-aab4-cbb5b46f39d8-template--20532874019115__main"
    ).each(function () {
      $(this)
        .find(".accordion__content")
        .html(
          '<img src="https://cdn.shopify.com/s/files/1/0801/2873/7579/files/green-story__impact.png?v=1693184220">'
        );
      // $(this).attr("open", "open");
    });

  }, 200);

  // expand accordion
  setTimeout(function () {
    $('.tri-accordion-wrapper .accordion-item:first-child .accordion-content-wrapper').removeClass('closed');
  }, 100);


  


  
});
